import { render, staticRenderFns } from "./NotifiedUsersChip.vue?vue&type=template&id=c2a5f3d4&scoped=true"
import script from "./NotifiedUsersChip.vue?vue&type=script&lang=js"
export * from "./NotifiedUsersChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a5f3d4",
  null
  
)

export default component.exports